import { injectable } from '@patsnap/tahiti-core/shared/inversify';
import { GuestAwareHttpService } from '../../services/guest-aware-http-service';
import type {
    CcReportApi,
    CcReportRequest,
    CcReportResponse,
} from '../cc-report-api';

/**
 * CC 结构化结果报告接口实现。
 */
@injectable()
export class CcReportApiImpl extends GuestAwareHttpService implements CcReportApi {
    /**
     * 查询参数严格使用接口文档定义的 task_id，不额外传递页面字段。
     */
    getReport(request: CcReportRequest): Promise<CcReportResponse> {
        return this.getWithGuestSupport<CcReportResponse>(
            'cc_compare/report',
            {
                task_id: request.task_id,
            }
        );
    }
}
